module.exports = __webpack_public_path__ + "img/智慧煤矿.ea0401ef.png";